import { render, staticRenderFns } from "./SettingDetails.vue?vue&type=template&id=01d535d8"
import script from "./SettingDetails.vue?vue&type=script&lang=js"
export * from "./SettingDetails.vue?vue&type=script&lang=js"
import style0 from "./SettingDetails.vue?vue&type=style&index=0&id=01d535d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports